import { UsuarioComboItem, UsuarioEditIn, UsuarioEditOut, UsuarioListOut, UsuarioLoginInfoOut } from '../../../../model/seguridad';
import { IPaginatedResponse, IResponse } from '../../../model';
import ServiceBase from '../../../servicebase';

export default class UsuarioService extends ServiceBase {
  get = (data:{ login?: string }) : Promise<IResponse<UsuarioLoginInfoOut>> => 
    this.GetFetch<IResponse<UsuarioLoginInfoOut>>('entity/usuario/login-info', data);

  getEdit = (data:{ login?: string, id?: number }) : Promise<IResponse<UsuarioEditOut>> => 
    this.GetFetch<IResponse<UsuarioEditOut>>('entity/usuario/edit', data);

  combo = (data:{ activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number, hasRol?: string }) => 
    this.GetFetch<IResponse<UsuarioComboItem[]>>('entity/usuario/combo', data);

  token = (data:{ username: string, password: string }) : Promise<IResponse<string>> => 
    this.GetFetch<IResponse<string>>('entity/usuario/token', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, cliente?: string, nombre?:string, apellido?:string, login?:string, activo?:boolean, idroles?: string }) => 
    this.GetFetch<IPaginatedResponse<UsuarioListOut>>('entity/usuario/find', data);

  upsert = (data: UsuarioEditIn) => 
    this.PostFetch<IResponse<number>>('entity/usuario', data);

  delete = (data:{ id: number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/usuario', data);  
  
  setPassword = (data: { usuario?: number; password?: string; hidentoken: string }) : Promise<IResponse<boolean>>  =>
    this.PostFetch<IResponse<boolean>>('entity/usuario/setpassword', data);

}
